/* src/app/private/components/fee-group/delete-fee-group/delete-fee-group.component.scss */
/*# sourceMappingURL=delete-fee-group.component.css.map */
